import { Form, InputGroup } from 'react-bootstrap';
import './DefaultInput.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, faCalendar, faIdCard, faKeyboard, faMoneyBill1 } from '@fortawesome/free-regular-svg-icons';
import React from 'react';
import { faAt, faBuilding, faLock, faPercent, faPerson } from '@fortawesome/free-solid-svg-icons';
import ReactDOM from 'react-dom';
import { useAppSelector } from '../../Redux/hooks';

export interface DefaultInputProps {
    onChange?: (value: any) => void;
    type: "number" | "email" | "password" | "text" | "currency";
    iconKey?: string;
    placeholder: string;
    required?: boolean;
    value?: any;
    disabled?: boolean;
    readOnly?: boolean;
    params?: Partial<PropsParams>
}

interface PropsParams {
    numberIsInterger: boolean;
    numberIsPercentage: boolean;
    numberMinValue: number;
    numberMaxValue: number;
}


export const DefaultInput = React.forwardRef((props: DefaultInputProps, ref: any) => {
    const [inputValue, setInputValue] = React.useState<any>("");
    const inputRef = React.useRef<HTMLInputElement>(null);
    const clientConfig = useAppSelector(state => state.clientConfig.config);
    
    const loadParams = () => {
        const ret: PropsParams = {
            numberIsInterger: props?.params?.numberIsInterger ?? false,
            numberIsPercentage: props?.params?.numberIsPercentage ?? false,
            numberMinValue: props?.params?.numberMinValue ?? 0,
            numberMaxValue: props?.params?.numberMaxValue ?? 9999999999,
        }
        return ret
    }
    const [params, setParams] = React.useState<PropsParams>(loadParams())
    
    React.useEffect(() => {
        if (props.value !== undefined)
            setInputValue(props.value);
    }, [props.value])

    React.useEffect(() => {
        setParams(loadParams())
    }, [props?.params])

    const renderIcon = (): IconDefinition => {
        switch (props.iconKey) {
            case "currency":
                return faMoneyBill1;
            case "email":
                return faAt;
            case "password":
                return faLock;
            case "name":
                return faPerson;
            case "identity":
                return faIdCard;
            case "building":
                return faBuilding;
            case "percent":
                return faPercent
            case "calendar":
                return faCalendar;
            default:
                return faKeyboard;
        }
    }

    const onInputChange = (event: any) => {
        if (props.type === "number") {
            let value = params.numberIsInterger ? parseInt(event.target.value) : parseFloat(event.target.value);
            const minValue = params.numberIsPercentage ? 0 : params.numberMinValue
            const maxValue = params.numberIsPercentage ? 100 : params.numberMaxValue

            if (value >= minValue) {
                if (value <= maxValue) {
                    if (props.onChange !== undefined)
                        props.onChange(value);
                    setInputValue(value);
                } else return;
            }
            else {
                setInputValue("");
                if (props.onChange !== undefined)
                    props.onChange(0);
            }
        }
        if (props.type === "currency") {
            // Remove spaces
            let value = params.numberIsInterger ? parseInt(event.target.value) : parseFloat(event.target.value.replace(/ /g, ''));

            if (value >= params.numberMinValue) {
                if (value <= params.numberMaxValue) {
                    if (props.onChange !== undefined)
                        props.onChange(value);
    
                    // Add spaces for better readability
                    let formattedValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                    setInputValue(formattedValue);
                } else return
            }
            else {
                setInputValue("");
                if (props.onChange !== undefined)
                    props.onChange(0);
            }
        }
        else {
            if (event && event.target) {
                if (props.onChange !== undefined)
                    props.onChange(event.target.value);
                setInputValue(event.target.value);
            }
        }
    }

    const addStyle = () => {
        (ReactDOM.findDOMNode(inputRef.current) as any).style.boxShadow = `0 0 0 0.05rem ${clientConfig?.primaryColor}`;
        (ReactDOM.findDOMNode(inputRef.current) as any).style.borderRadius = '0.40rem';
    }

    const removeStyle = () =>{
        (ReactDOM.findDOMNode(inputRef.current) as any).style.boxShadow = 'none';
        (ReactDOM.findDOMNode(inputRef.current) as any).style.borderRadius = '0';
    }

    return (
        <>
            {
                props.iconKey ?
                    <InputGroup ref={inputRef} className="defaultInputGroup">
                        <InputGroup.Text className={`inputIcon ${props.disabled ? "disabledIcon" : ""}`}><FontAwesomeIcon width={16} icon={renderIcon()} /></InputGroup.Text>
                        <Form.Control
                            required={props.required}
                            className="defaultInput withIcon"
                            onChange={onInputChange}
                            value={inputValue}
                            type={props.type}
                            placeholder={props.placeholder}
                            disabled={props.disabled}
                            onFocus={addStyle}
                            onBlur={removeStyle}
                            readOnly={props.readOnly}
                        />
                    </InputGroup>
                    :
                    <Form.Control
                        ref={ref}
                        required={props.required}
                        className="defaultInput"
                        onChange={onInputChange}
                        value={inputValue}
                        type={props.type}
                        placeholder={props.placeholder}
                        readOnly={props.readOnly}
                    />
            }
        </>
    );
});